<template>
  <div>
    <Main ref="tableMain" :loading="loading" :tableData="tableData"> </Main>
  </div>
</template>
<script>
import Main from './main'
export default {
  components: { Main },
  props: {
    orderGoodsPackageDocCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      tableData: [],
      loading: false,
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.orderGoodsPackageDocCode) return
      this.loading = true
      this.$api
        .pendingOrderGoodsPackageDocGoodsListApi({
          orderGoodsPackageDocCode: this.orderGoodsPackageDocCode,
        })
        .then((res) => {
          this.loading = false
          this.tableData = res.body.data
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
}
</script>
